import { ModalHead, Prompt, PromptBody, Tile, TileGrid, Title } from 'admination-react'

export function AnlegenWahlPrompt({
  onPerson,
  onListe,
  onClose,
}: {
  onPerson: () => void
  onListe: () => void
  onClose: () => void
}) {
  return (
    <Prompt
      onEscape={onClose}
      topbar={<ModalHead onClose={onClose} closeLabel="Schließen" />}
      aria-labelledby="anlegen-wahl-titel"
    >
      <PromptBody>
        <Title as="h3" id="anlegen-wahl-titel">
          Teilnehmende anlegen
        </Title>
        <TileGrid>
          <Tile onClick={onPerson}>Teilnehmende Person anlegen</Tile>
          <Tile onClick={onListe}>Zuweisungsliste hochladen</Tile>
        </TileGrid>
      </PromptBody>
    </Prompt>
  )
}
